var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 4.23126C22 2.99897 20.9926 2 19.75 2H9.25C8.00736 2 7 2.99897 7 4.23126V6.5H14.75C16.784 6.5 18.5 8.1164 18.5 10.1921V13.1563H19L20.6643 15.2194C21.1072 15.7684 22 15.4578 22 14.7548V4.23126Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 10.1921C2 8.98144 3.00736 8 4.25 8H14.75C15.9926 8 17 8.98144 17 10.1921V17.5789C17 18.7896 15.9926 19.7711 14.75 19.7711H5L3.33565 21.7243C2.89277 22.2637 2 21.9586 2 21.2679V10.1921ZM6.5 14C6.5 13.4477 6.05228 13 5.5 13C4.94772 13 4.5 13.4477 4.5 14C4.5 14.5523 4.94772 15 5.5 15C6.05228 15 6.5 14.5523 6.5 14ZM10.5 14C10.5 13.4477 10.0523 13 9.5 13C8.94772 13 8.5 13.4477 8.5 14C8.5 14.5523 8.94772 15 9.5 15C10.0523 15 10.5 14.5523 10.5 14ZM13.5 15C14.0523 15 14.5 14.5523 14.5 14C14.5 13.4477 14.0523 13 13.5 13C12.9477 13 12.5 13.4477 12.5 14C12.5 14.5523 12.9477 15 13.5 15Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComments);
export default __webpack_public_path__ + "static/media/comments.d001ff01e2d589cd2ab54f1eb7a1f01c.svg";
export { ForwardRef as ReactComponent };